var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn registration-navbar--button my-2 my-sm-0 pl-4 pr-4",on:{"click":function($event){return _vm.goToDashboard()}}},[_vm._v("Vai al profilo")])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27386071","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/course/GoDashboardButton.vue
// module id = OkkI
// module chunks = 36